<template>
  <div class="welcome">
    <div class="welcome__innerwrap">
      <div class="welcome__content-wrap">
        <h1 class="welcome__title" v-html="page.title"></h1>
        <div class="welcome__content" v-html="page.content"></div>
      </div>
    </div>
    <bottom-nav
      :prev="{ to: '/', label: 'Home' }"
      :next="{ to: '/intro', label: 'Product information' }"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BottomNav from '@/components/BottomNav';

export default {
  name: 'Welcome',
  components: { BottomNav },
  computed: {
    ...mapState(['pages']),
    page() {
      return this.pages.welcome;
    },
  },
};
</script>

<style lang="scss">
@import '../styles/helpers';

.welcome {
  @include section(true);

  &__content-wrap {
    width: 10/12 * 100%;
  }

  &__title {
    @include font-heading;

    em {
      display: inline-block;
      position: relative;
      font: inherit;
      position: relative;

      &::after {
        content: '';
        display: block;
        position: absolute;
        top: calc(100% - .15em);
        left: -.15em;
        width: 100%;
        padding-top: 4.6%;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('../assets/welcome_underscore.svg');
      }
    }
  }

  &__content {
    @include font-content;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Welcome.vue